<template>
  <div class="mem_wrap">
    <div class="toolbar">
      <el-form :inline="true" :model="queryForm" class="query_form" @submit.native.prevent>
        <el-form-item label="数字员工">
          <el-select v-model="queryForm.agent_id" placeholder="全部" clearable filterable style="width: 180px">
            <el-option v-for="a in agentOptions" :key="a.agent_id"
                       :label="a.display_name || a.name" :value="a.agent_id" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 服务端 limit 强制上限 100 -->
    <el-alert v-if="total >= 100" type="info" :closable="false" show-icon class="cap_tip"
              title="单页最多展示 100 条记忆" />

    <el-table :data="tableData" v-loading="loading" border>
      <el-table-column label="类型" width="90">
        <template slot-scope="scope">
          <el-tag :type="(KINDS[scope.row.kind] || {}).tag || 'info'" size="small">
            {{ (KINDS[scope.row.kind] || {}).text || scope.row.kind || '-' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="内容" min-width="280" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.content || '-' }}</template>
      </el-table-column>
      <el-table-column label="数字员工" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">{{ agentName(scope.row.agent_id) }}</template>
      </el-table-column>
      <el-table-column prop="importance" label="重要性" width="90">
        <template slot-scope="scope">{{ scope.row.importance }}</template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 'active' ? 'success' : 'info'" size="small">
            {{ scope.row.status === 'active' ? '注入中' : '已归并' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="写入时间" width="160">
        <template slot-scope="scope">{{ fmtTime(scope.row.ctime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
          <el-button v-if="canDel" type="text" size="small" class="danger_text" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagesize"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />

    <!-- 详情弹窗 -->
    <el-dialog title="记忆详情" :visible.sync="detailVisible"
               width="640px" v-dialogDrag :modal-append-to-body="false" v-if="detailVisible">
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="记忆 ID">{{ detail.memory_id }}</el-descriptions-item>
        <el-descriptions-item label="数字员工">{{ agentName(detail.agent_id) }}</el-descriptions-item>
        <el-descriptions-item label="类型">{{ (KINDS[detail.kind] || {}).text || detail.kind || '-' }}</el-descriptions-item>
        <el-descriptions-item label="重要性">{{ detail.importance }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ detail.status === 'active' ? '注入中' : '已归并' }}</el-descriptions-item>
        <el-descriptions-item label="写入时间">{{ fmtTime(detail.ctime) }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ fmtTime(detail.utime) }}</el-descriptions-item>
        <el-descriptions-item label="来源会话">{{ detail.session_id || '-' }}</el-descriptions-item>
        <el-descriptions-item label="来源轮次">{{ detail.turn_id || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div class="detail_content_title">内容</div>
      <pre class="pre_text">{{ detail.content }}</pre>
    </el-dialog>
  </div>
</template>

<script>
import { agentBody, isEnterprise, isAdminAcc } from '../utils'

// 记忆类型四色
const KINDS = {
  fact: { text: '事实', tag: '' },
  preference: { text: '偏好', tag: 'success' },
  routine: { text: '惯例', tag: 'warning' },
  summary: { text: '摘要', tag: 'info' }
}

// 记忆管理：按 agent 筛选查看（企业可删；排序由服务端按 importance desc, utime desc）
export default {
  name: 'AiAgentMemory',
  data() {
    return {
      KINDS,
      canDel: isEnterprise(),
      queryForm: { agent_id: '' },
      agentOptions: [],
      tableData: [],
      loading: false,
      currentPage: 1,
      pagesize: 20,
      total: 0,
      reqSeq: 0,
      detailVisible: false,
      detail: {}
    }
  },
  mounted() {
    // 个人/企业可见；平台账号常驻挂载下发请求会 3004 弹错，跳过自动加载
    if (isAdminAcc()) return
    this.loadAgents()
    this.loadList()
  },
  methods: {
    loadAgents() {
      return this.$tools.asyncPost(this, this.$baseUrl.aiAgentAgentsList,
        agentBody({ page: 1, limit: 0 })).then((res) => {
        if (res.data.code == 0) this.agentOptions = res.data.data.data || []
      }).catch(() => {})
    },
    agentName(id) {
      const a = this.agentOptions.find(x => x.agent_id === id)
      return a ? (a.display_name || a.name) : (id || '-')
    },
    loadList() {
      this.loading = true
      const data = { page: this.currentPage, limit: this.pagesize }
      if (this.queryForm.agent_id) data.agent_id = this.queryForm.agent_id
      const seq = ++this.reqSeq
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentMemoryList, agentBody(data)).then((res) => {
        if (seq !== this.reqSeq) return
        if (res.data.code == 0) {
          this.tableData = res.data.data.data || []
          this.total = res.data.data.total || 0
        }
        this.loading = false
      }).catch((err) => {
        if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        if (seq === this.reqSeq) this.loading = false
      })
    },
    onSearch() {
      this.currentPage = 1
      this.loadList()
    },
    resetQuery() {
      this.queryForm = { agent_id: '' }
      this.onSearch()
    },
    handleSizeChange(val) { this.pagesize = val; this.currentPage = 1; this.loadList() },
    handleCurrentChange(val) { this.currentPage = val; this.loadList() },
    openDetail(row) {
      this.detail = row
      this.detailVisible = true
    },
    handleDel(row) {
      this.$MessageBox.confirm('删除后该记忆不再注入对话且不可恢复，确认删除？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentMemoryDel,
          agentBody({ memory_id: row.memory_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '删除成功' })
            if (this.tableData.length === 1 && this.currentPage > 1) this.currentPage -= 1
            this.loadList()
          }
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        })
      }).catch(() => {})
    },
    // 主入口切 Tab 激活时刷新
    onActivate() {
      this.loadAgents()
      this.loadList()
    },
    fmtTime(s) {
      // 字段为零值时后端可能返回 Go 零值时间（0001-01-01T00:00:00Z），按空处理
      if (!s || String(s).indexOf('0001-01-01') === 0) return '-'
      const t = this.$tools.parserDateTime('datetime', s)
      // parserDateTime 对非法输入返回 NaN 串恒非空，回退原文截断
      if (t && t.indexOf('NaN') < 0) return t
      return String(s).substring(0, 19).replace('T', ' ')
    }
  }
}
</script>

<style lang="less" scoped>
.cap_tip {
  margin-bottom: 12px;
}
.danger_text {
  color: #f56c6c;
}
.detail_content_title {
  margin: 12px 0 6px;
  font-weight: bold;
}
.pre_text {
  margin: 0;
  max-height: 300px;
  overflow: auto;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
  background: #f5f7fa;
  padding: 10px;
  border-radius: 4px;
}
</style>
